import { useState, useMemo, useCallback, memo } from "react";
import { Table, Typography, Image } from "antd";
import EyeIcon from "../../../assets/icons/eye.svg";
import CustomButton from "../../../components/CustomButton/Button";
import AccountDetails from "../../../components/AccountDetails/AccountDetails";
import { TITLE_TXT } from "../../../constants/constants";
import { TABLE_PAGINATION } from "../../../constants/tableConfig";
import CustomModal from "../../../components/CustomModal/CustomModal";

const { Text } = Typography;

const EntBreakdownTable = ({ wallet }) => {
    const [escrowDetailsOpen, setEscrowDetailsOpen] = useState(false);
    const [selectedRecord, setSelectedRecord] = useState(null);

    const handleViewEscrow = useCallback((record) => {
        setSelectedRecord(record);
        setEscrowDetailsOpen(true);
    }, []);

    const handleCloseEscrowModal = useCallback(() => {
        setEscrowDetailsOpen(false);
    }, []);

    const columns = useMemo(
        () => [
            {
                title: "Enterprise Name",
                dataIndex: "entName",
                key: "entName",
                render: (text) => <Text strong>{text}</Text>,
            },
            {
                title: "Available Balance",
                key: "amount",
                render: (_, record) =>
                    `₹ ${Number(record?.BankDetailsView?.amount || 0).toLocaleString("en-IN")}`,
            },
            {
                title: "Virtual Account Details",
                key: "action",
                render: (_, record) => (
                    <CustomButton
                        type="text"
                        icon={<Image preview={false} src={EyeIcon} alt="view" />}
                        onClick={() => handleViewEscrow(record)}
                    />
                ),
            },
        ],
        [handleViewEscrow]
    );

    const entDetails = wallet?.entDetails ?? [];

    return (
        <>
            <Table
                columns={columns}
                dataSource={entDetails}
                pagination={TABLE_PAGINATION}
                rowKey="busEntId"
                className="ent-breakdown-table"
            />
            <CustomModal
                open={escrowDetailsOpen}
                centered
                onCancel={handleCloseEscrowModal}
                content={
                    <AccountDetails
                        title={TITLE_TXT.BUS_ENT_ESCW_ACC_DETS}
                        details={selectedRecord?.BankDetailsView}
                    />
                }
                width={650}
            />
        </>
    );
};

export default memo(EntBreakdownTable);
